/**
 * 财务中心--》财务准备
 */

export default {
    show_lsxl_btn: ['80831', '76955', '93386', '76370', '97279','86020','68199','87009','96083','85780'], //202507011704106004592, 202506161626412808323,财务准备 显示隶属线路功能，以往工单202503031859295277404,https://imagecdn.ymm56.com/ymmfile/static-resource/lq/uniapp/assets/showLsxl.png
    custom_ls_site_copy_lsxl:['86980'], // 202509281413156109561 86980 自定义隶属站点复制隶属线路功能(线路值改成站点) 但不显示财务准备的隶属线路开关及隶属线路利润表 且需开通window.LQAPI.getAllGrayConfig(["LINE_LS"])公版隶属线路开关 https://imagecdn.ymm56.com/ymmfile/static/resource/45148926-3d7e-470e-96f0-21ddd89dc401.png
    // 202510281105536503968线路隶属,发站到站可以相同
    custom_line_ls_same_start_end:['90316', '82635'],
    // 去向方式支持设置期初余额
    custom_way_initial_balance:['75360'], // 202510181527421031497
  }
  